var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderControls", {
        attrs: { myWeek: false },
        on: { collapseToggleUpdated: _vm.collapseToggleUpdate }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-main container-fluid" },
        [
          _vm.systemSettingsReady
            ? _c("SocialScheduleCalendar", {
                attrs: { myWeek: false, expandAll: _vm.expandAll },
                on: { collapseToggleUpdated: _vm.collapseToggleUpdate }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }